import { render, staticRenderFns } from "./notificacionContingency.vue?vue&type=template&id=d4e882a4&scoped=true&"
import script from "./notificacionContingency.vue?vue&type=script&lang=js&"
export * from "./notificacionContingency.vue?vue&type=script&lang=js&"
import style0 from "./notificacionContingency.vue?vue&type=style&index=0&id=d4e882a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e882a4",
  null
  
)

export default component.exports